"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
require("./Button.scss");
var _antd = require("antd");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CustomButton = _ref => {
  let {
    title,
    buttonStyle,
    icon,
    rightIcon,
    size,
    variant,
    disabled,
    onClick,
    className,
    testid,
    redirect,
    redirectText,
    url,
    iconStyle,
    borderWidth,
    buttonContainerStyle
  } = _ref;
  const getRequitedStyle = variant => {
    switch (variant) {
      case "primary":
        return _objectSpread({
          color: disabled ? "#9A9A9A" : '#fff ',
          backgroundColor: disabled ? "#BFC1C4" : '#006E96',
          borderRadius: 10,
          justifyContent: 'center',
          borderColor: disabled ? "#BFC1C4" : '#006E96'
        }, buttonStyle);
      case "primary-long":
        return _objectSpread({
          backgroundColor: disabled ? "#BFC1C4" : '#006E96',
          justifyContent: 'center',
          width: '100%',
          borderRadius: 10,
          color: disabled ? "#9A9A9A" : '#fff '
        }, buttonStyle);
      case "outline-primary":
        return _objectSpread({
          borderColor: disabled ? "#BFC1C4" : '#006E96',
          justifyContent: 'center',
          color: disabled ? "#9A9A9A" : '#006E96',
          borderRadius: 10
        }, buttonStyle);
      case "outline-primary-long":
        return _objectSpread({
          borderColor: disabled ? "#BFC1C4" : '#006E96',
          justifyContent: 'center',
          color: disabled ? "#9A9A9A" : '#006E96',
          width: '100%',
          borderWidth: borderWidth || '1px',
          borderRadius: 10
        }, buttonStyle);
      case "nav-primary":
        return _objectSpread({
          borderColor: '#006E96',
          fontSize: 16,
          border: 0,
          justifyContent: rightIcon ? 'between' : "",
          fontWeight: 'normal',
          width: '200px',
          fontFamily: 'Poppins',
          textAlign: 'left',
          marginTop: '5%',
          marginBottom: '5%',
          color: "#333333",
          padding: 1,
          borderRadius: 'none',
          borderBottom: '2px solid #EBEBEB'
        }, buttonStyle);
      case "nav-link-button":
        return _objectSpread({
          borderColor: '#006E96',
          justifyContent: rightIcon ? 'between' : "",
          alignItems: 'center',
          border: 0,
          borderRadius: 'none',
          padding: 0,
          fontWeight: 600,
          width: '200px',
          fontFamily: 'Poppins',
          textAlign: 'left',
          left: 0,
          color: '#006E96'
        }, buttonStyle);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "Button",
    style: buttonContainerStyle
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    "data-testid": testid,
    key: title,
    className: "d-flex",
    onClick: e => onClick(e),
    disabled: disabled,
    size: size,
    style: getRequitedStyle(variant),
    variant: variant
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    style: iconStyle
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: "button-title-text"
  }, title), redirect ? /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer",
    style: {
      fontWeight: 'normal',
      width: '100%',
      // fontFamily: 'Poppins',
      marginTop: '5%',
      marginBottom: '5%',
      color: "#333333",
      borderBottom: '2px solid #EBEBEB',
      fontSize: "16px"
    }
  }, redirectText) : null, rightIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: "ms-auto",
    style: {
      marginRight: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Image, {
    src: rightIcon
  }))));
};
var _default = exports.default = CustomButton;